import { DialogMemberType } from '@common/model/dialog/dialogMemberType';
import { DialogMemberViewModel } from '@common/model/dialog/dialogMemberViewModel';

export const getMembersByEntity = (
  members: DialogMemberViewModel[],
  entityParams: { entityId: number; memberType: DialogMemberType },
): DialogMemberViewModel[] => {
  return members.filter((member) => member.entityId === entityParams.entityId && member.type === entityParams.memberType);
};
